import f3tch from 'f3tch';

// Constants
import API_URL from '../../api/constants/url.constant.api';

// Profiles
import profile from '../../api/profiles/json.profile.api';

const getTokensApi = (params) =>
  f3tch('/auth/token')
    .profile(profile({authorize: false, url: API_URL()}))
    .body(params)
    .post();

export default getTokensApi;
